import { DateFormatterParams, CalendarAngularDateFormatter, DateAdapter } from 'angular-calendar';
import { DatePipe } from '@angular/common';
import { Injectable, Inject } from "@angular/core";

@Injectable()
export class CustomDateFormatter extends CalendarAngularDateFormatter {
  constructor(@Inject(DateAdapter) dateAdapter: any) {
      super(dateAdapter);
  }
    // you can override any of the methods defined in the parent class

    public dayViewHour({ date, locale }: DateFormatterParams): string {
        return new DatePipe(locale).transform(date, 'HH:mm', locale);
    }

    public weekViewHour({ date, locale }: DateFormatterParams): string {
        return this.dayViewHour({ date, locale });
    }

    public monthViewColumnHeader({
        date,
        locale
    }: DateFormatterParams): string {
        const dayLabel = new DatePipe(locale).transform(date, 'EEEE', locale);
        return dayLabel.substring(0, 2);
    }

    public weekViewColumnHeader({ date, locale }: DateFormatterParams): string {
        const dayLabel = new DatePipe(locale).transform(date, 'EEEE', locale);
        return dayLabel.substring(0, 3);
    }

    public weekViewColumnSubHeader({
        date,
        locale
    }: DateFormatterParams): string {
        return new DatePipe(locale).transform(date, 'd', locale);
    }
}
